import React, { Component } from 'react';
import { Pagination } from "react-bootstrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import { PAGE_LIMIT } from "./config";
import { handleFieldChange } from "../../Utils";

class BidderCtr extends Component {
    constructor() {
        super();

        this.state = {
            sources: [],
            affids: [],
            report: [],
            total: {},
            sortParam: null,
            sortOrder: 1,
            pagesTotal: 0,
            activePage: 1,
            isLoading: false
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
    }

    componentDidMount() {
        this.loadSources();
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;


        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report, activePage: 1 });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        if(type === 'affid') return this.loadAffid(filters);

        this.loadReport(filters, type);
    }

    loadReport(filters) {
        API.BidderCtr.get(filters).then((report) => {
            const pagesTotal = Math.ceil(report.length / PAGE_LIMIT);

            this.setState({ report, activePage: 1, pagesTotal, isLoading: false })
        });
    }

    loadSources() {
        this.setState({ isLoading: true });

        API.BidderSources.getAvailableSources().then(sources => this.setState({ sources, isLoading: false }));
    }

    loadAffid(filters) {
        API.BidderCtr.getAffids(filters).then(affids => {
            this.setState({ affids, isLoading: false })
        });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    getTable() {
        let { report, activePage } = this.state;

        if(report.length) {
            const pageStart = ( activePage - 1 ) * PAGE_LIMIT;
            const pageEnd = activePage * PAGE_LIMIT;
            report = report.slice(pageStart, pageEnd);

            return <Table report={report} onSortChange={this.handleSort}/>;
        }

        return <p>No Data</p>
    }

    render() {
        const { isLoading, sources, affids } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder CTR"/>
                <Form onSubmit={this.handleSubmit} sources={sources} affidValues={affids}/>

                {this.getTable()}

                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default BidderCtr;


// WEBPACK FOOTER //
// ./src/scenes/BidderCtr/index.js